import {ParamsProps} from '@/components/WdiBus/FormPage';
import {Enum} from '@/enums/system';
import {ResponseStatus} from '@/utils/request';
import {wdiCore, WdiModalAppResult} from '@/components/WdiControls';
import {FormApi} from '@/services/sales';
import {FormSp, FormSpDetail} from '@/services/sales/sp';
import {DataOptions} from '@/services/basic/metadata';
import {FileUploadUtility} from '@/components/WdiControls/WdiFileUpload';
import moment from 'moment';
import {WdiSelectFormat} from '@/components/WdiControls/WdiSelect';
import {Invoices} from "@/services/sales/financial/invoices";

export type ViewEntityProps = {
  form?: API.Form;
  formSp?: API.FormSp;
  paymentMethod?: API.DataOptions;
  supplier?: API.Supplier;
  formSpDetails?: API.FormSpDetail[];
  formSpAdvances?: API.FormSpAdvance[];
  relationType?: number;
  relatedFormId?: number;
  formId?: number;
  statusId?: number;
  formTypeId?: number;
  pageTypeId?: number;
  paymentMethodId?: number;
  invoiceMakerCode?: string;
  supplierId?: number;
  ecId?: number;
  soldToCode?: string;
  soldToMasterId?: number;
  vatTypeId?: number;
  reimburseType?: number;
  userId?: number;
  positionId?: number;
  deptId?: number;
  companyCode?: string;
  invoiceStatus?: number;
};

export const initApplyPageContext = async (params: ParamsProps) => {
  const result: WdiModalAppResult = {
    code: ResponseStatus.UNKNOWN
  };
  const viewEntity: ViewEntityProps = {};
  if (params.formId || params.relatedFormId) {
    // 退回待修改
    const formResponse = await FormApi.get(params.formId || params.relatedFormId || 0);
    viewEntity.form = formResponse.data;
    if (!viewEntity.form) {
      result.message = "无效的退回待修改单";
      return result;
    }
    if (params.formId) {
      viewEntity.formId = params.formId;
    } else {
      viewEntity.relationType = Enum.FormRelationType.REJECTED;
      viewEntity.relatedFormId = params.relatedFormId;
    }
    const formSPResponse = await FormSp.get(viewEntity.form.formId);
    viewEntity.formSp = formSPResponse.data;
    viewEntity.reimburseType = viewEntity.formSp.reimburseType;
    viewEntity.userId = viewEntity.form.userId;
    viewEntity.positionId = viewEntity.form.positionId;
    viewEntity.deptId = viewEntity.form.deptId;
    viewEntity.pageTypeId = viewEntity.form.pageTypeId;
    viewEntity.formTypeId = viewEntity.form.formTypeId;
    4;
    viewEntity.companyCode = formSPResponse.data.companyCode;
    viewEntity.supplierId = formSPResponse.data.supplierId;
  } else {
    // 直接申请
    viewEntity.paymentMethodId = params.paymentMethodId;
    viewEntity.invoiceMakerCode = params.invoiceMakerCode;
    viewEntity.supplierId = params.supplierId;
    viewEntity.ecId = params.ecId;
    viewEntity.soldToMasterId = params.soldToMasterId;
    viewEntity.soldToCode = params.soldToCode;
    viewEntity.pageTypeId = params.pageTypeId;
    viewEntity.formTypeId = params.formTypeId;
    viewEntity.reimburseType = params.reimburseType;
    viewEntity.userId = params.userId;
    viewEntity.positionId = params.positionId;
    viewEntity.deptId = params.deptId;
    viewEntity.companyCode = params.companyCode;
  }

  if (viewEntity.form) {
    const formSPDetailsResponse = await FormSpDetail.getsForRebate(viewEntity.form.formId);
    viewEntity.formSpDetails = formSPDetailsResponse.data;
    viewEntity.paymentMethodId = viewEntity.formSpDetails?.[0].paymentMethodId;
    viewEntity.vatTypeId = viewEntity.formSpDetails?.[0].vatTypeId;
    viewEntity.supplierId = viewEntity.formSpDetails?.[0].supplierId;
    if (!viewEntity.soldToMasterId) {
      viewEntity.soldToCode = viewEntity.formSpDetails?.[0].soldToCode;
    }
  }
  if (viewEntity.paymentMethodId) {
    const paymentMethodResponse = await DataOptions.search({
      typeGroup: 5,
      inValues: String(viewEntity.paymentMethodId)
    });
    viewEntity.paymentMethod = paymentMethodResponse.data[0];
  }

  if (viewEntity.pageTypeId == Enum.PageType.PAYMENT_CONTRACT_ACCOUNT_REDUCE
    || viewEntity.pageTypeId == Enum.PageType.PAYMENT_CONTRACT_THIRD_PART) {
    viewEntity.invoiceStatus = Enum.InvoiceStatus.WITH_INVOICE;
  }

  result.code = ResponseStatus.SUCCESS;
  result.data = viewEntity;
  return result;
}

export const initApprovalPageContext = async (params: ParamsProps) => {
  const result: WdiModalAppResult = {
    code: ResponseStatus.UNKNOWN
  };
  const viewEntity: ViewEntityProps = {};
  if (params.formId) {
    const formSPResponse = await FormSp.get(params.formId);
    viewEntity.formSp = formSPResponse.data;
    viewEntity.paymentMethodId = formSPResponse.data.paymentMethodId;
    if (!viewEntity.formSp) {
      result.message = "无效的单据";
      return result;
    }
    const formResponse = await FormApi.get(params.formId);
    viewEntity.form = formResponse.data;
    viewEntity.pageTypeId = formResponse.data.pageTypeId;

    const formSPDetailsResponse = await FormSpDetail.getsForRebate(params.formId);
    viewEntity.formSpDetails = formSPDetailsResponse.data;
    viewEntity.vatTypeId = viewEntity.formSpDetails[0].vatTypeId;
    viewEntity.paymentMethodId = viewEntity.formSpDetails[0].paymentMethodId;
  }

  result.code = ResponseStatus.SUCCESS;
  result.data = viewEntity;
  return result;
};

export const refreshApprovalPageContext = async (formId: number) => {
  const formSPResponse = await FormSp.get(formId);
  const formResponse = await FormApi.get(formId);
  // const formSPDetailsResponse = await FormSpDetail.getFormSpDetailsForSaApproval(formId);

  const data: { form: API.Form, formSp: API.FormSp, invoices?: API.FormInvoiceVo[] } = {
    form: formResponse.data,
    formSp: formSPResponse.data,
  };
  if (data.formSp.pageTypeId == Enum.PageType.PAYMENT_CONTRACT_ACCOUNT_REDUCE
    || data.formSp.pageTypeId == Enum.PageType.PAYMENT_CONTRACT_THIRD_PART) {
    const invoiceResp = await Invoices.getForPayment(formId);
    data.invoices = invoiceResp.data;
  }
  return data;
};

export const getRebatePaymentPageResult = (
  values: any,
  viewEntity: ViewEntityProps,
  pageType: API.PageType,
  statusId: number,
  dataSource: any[],
  invoiceDataSource?: any[],
  advanceDataSource?: any[],
  formGoods?: any[],
) => {
  const result: WdiModalAppResult = {code: ResponseStatus.UNKNOWN};

  const {
    fileInfo,
    dateAdjust,
    payOffDate,
    branchCompanyId,
    bankAccountId,
    soldToCodePayTo,
    oaFormNo,
    ...entity
  } = values;
  if (FileUploadUtility.isUploading(fileInfo)) {
    result.message = '附件正在上传中!';
    return result;
  }
  if (FileUploadUtility.isError(fileInfo)) {
    result.message = '附件存在错误文件!';
    return result;
  }
  const req: {
    form: any;
    formSp: any;
    formSpDetails: any[];
    invoices?: any[];
    formSpAdvances?: any[];
    formGoods?: any[];
  } = {
    form: {
      statusId: statusId,
      pageTypeId: pageType.pageTypeId,
      pageGroupId: pageType.pageGroupId,
      formTypeId: viewEntity.formTypeId,
      userId: viewEntity.userId,
      positionId: viewEntity.positionId,
      deptId: viewEntity.deptId,
    },
    formSp: {},
    formSpDetails: [],
    invoices: [],
    formSpAdvances: [],
    formGoods: [],
  };

  if (viewEntity.formSp) {
    if (viewEntity.relationType === Enum.FormRelationType.REJECTED) {
      // 退回待修改
      req.form.relatedFormId = viewEntity.relatedFormId;
      req.form.relationType = viewEntity.relationType;
    } else {
      // 从草稿打开
      req.form.formId = viewEntity.formId;
    }
  }
  entity.modifiedReason = '新建';
  entity.reimburseType = viewEntity.reimburseType;
  if (dataSource && dataSource.length < 1) {
    result.code = ResponseStatus.UNKNOWN;
    result.message = '费用明细信息不能为空';
    return result;
  }
  if (
    viewEntity.invoiceStatus == Enum.InvoiceStatus.WITH_INVOICE &&
    invoiceDataSource &&
    invoiceDataSource.length < 1
  ) {
    result.code = ResponseStatus.UNKNOWN;
    result.message = '发票信息不能为空';
    return result;
  }

  const info = FileUploadUtility.serialize(fileInfo);
  entity.fileName = info?.names;
  entity.filePath = info?.urls;
  if (dateAdjust) {
    entity.dateAdjust = moment(dateAdjust).format('YYYY-MM-DD');
  }
  if (payOffDate) {
    entity.payOffDate = moment(payOffDate).format('YYYY-MM-DD');
  }
  entity.branchCompanyId = WdiSelectFormat.getvalue(branchCompanyId);
  entity.paymentMethodId = viewEntity.paymentMethodId;
  entity.invoiceStatus = viewEntity.invoiceStatus || Enum.InvoiceStatus.NON_INVOICE;
  entity.soldToMasterId = viewEntity.soldToMasterId;
  entity.soldToCode = viewEntity.soldToCode;
  entity.ecId = viewEntity.ecId;
  entity.supplierId = viewEntity.supplierId;
  entity.invoiceMakerCode = viewEntity.invoiceMakerCode;
  entity.bankAccountId = WdiSelectFormat.getvalue(bankAccountId);
  entity.soldToCodePayTo = WdiSelectFormat.getvalue(soldToCodePayTo);
  if (oaFormNo) {
    entity.oaFormNo = oaFormNo.oaFormNo;
    entity.oaFormName = oaFormNo.oaFormName;
    entity.url = oaFormNo.url;
  }

  req.formSp = entity;

  dataSource?.forEach((item, itemIndex) => {
    item.rowNumber = itemIndex + 1;
    item.formSpDetailId = item.formSpDetailId || 0;
    item.formSpId = item.formSpId || 0;
    item.productBuyIds = item.productIdsRebate;
    item.soldToCodePayTo = entity.soldToCodePayTo;
  });
  req.formSpDetails = dataSource;
  req.invoices = invoiceDataSource;
  req.formSpAdvances = advanceDataSource?.map((item) => {
    return Object.assign(
      {...item},
      {createDate: wdiCore.Date.DateToString(wdiCore.Date.Parse2(item.createDate))},
    );
  });
  req.formGoods = formGoods;

  result.data = req;
  result.code = ResponseStatus.SUCCESS;
  return result;
};

export const moreConfig: any = {
  successParams: [
    {
      url: "/basicapi/favorite/getButtons",
      keys: []
    }, {
      url: "/expenseapi/spButtons/get",
      keys: [
        "UndoButton",
        "ReeditButton",
        "CancelButton",
        "InterveneFlowButton",
        "AppendExtNodeButton",
        'AddMailApproverButton',
        "ExpediteFlowButton",
        "FormSpPrintButton"
      ]
    }
  ],
  errorParams: [
    {
      url: "/expenseapi/spButtons/get",
      keys: [
        "RepairButton",
        "InterveneFlowButton"
      ]
    }
  ]
};

export const tpMoreConfig: any = {
  successParams: [
    {
      url: "/basicapi/favorite/getButtons",
      keys: []
    }, {
      url: "/expenseapi/spButtons/get",
      keys: [
        "UndoButton",
        "ReeditButton",
        "CancelButton",
        "ModifyPayOffDateButton",
        "InterveneFlowButton",
        "AppendExtNodeButton",
        "TransferNodeButton",
        "FormSpPrintButton",
      ]
    }
  ],
  errorParams: [
    {
      url: "/expenseapi/spButtons/get",
      keys: [
        "RepairButton",
        "InterveneFlowButton"
      ]
    }
  ]
};

export const fgMoreConfig: any = {
  successParams: [
    {
      url: "/basicapi/favorite/getButtons",
      keys: []
    }, {
      url: "/expenseapi/spButtons/get",
      keys: [
        "UndoButton",
        "ReeditButton",
        "CancelButton",
        "InterveneFlowButton",
        "AppendExtNodeButton",
        "TransferNodeButton",
      ]
    }
  ],
  errorParams: [
    {
      url: "/expenseapi/spButtons/get",
      keys: [
        "RepairButton",
        "InterveneFlowButton"
      ]
    }
  ]
};

export const approvalConfig: any = {
  params: {
    url: "/expenseapi/spButtons/get",
    keys: [
      "ApprovalButton",
      "ReadButton",
    ]
  }
};
